<template>
  <div class="tg-document--item">
    <i :class="itemIcon"></i>
    <span>{{content}}</span>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    num: Number
  },
  computed: {
    itemIcon() {
      return ["tg-icon", "tg-icon-num-" + this.num];
    }
  }
};
</script>